import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

// Konfiguriši PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Licenses = () => {
  const openPdf = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const items = [
    {
      name: "Jelena Stamenković",
      image: "/images/licenca1.jpg",
      pdf: "/pdf/licenca1.pdf",
    },
    {
      name: "Milica Đinović",
      image: "/images/licenca2.jpg",
      pdf: "/pdf/licenca2.pdf",
    },
    {
      name: "Marko Sočanac",
      image: "/images/licenca3.jpg",
      pdf: "/pdf/licenca3.pdf",
    },
    {
      name: "Ovlašćenje za izdradu Akata",
      image: null, // nema slike, prikazujemo kao PDF
      pdf: "/pdf/ovlascenje.pdf",
    },
  ];

  return (
    <div className="licenses" id="licence">
      <div className="licenses-all-page">
        <div className="licenses-title">Licence i ovlašćenje</div>
        <div className="licenses-members">
          {items.map((item, index) => (
            <div
              key={index}
              className="licenses-member cursor-pointer bg-white shadow rounded-xl hover:shadow-lg transition p-2"
              onClick={() => openPdf(item.pdf)}
            >
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.name}
                  className="licenses-img"
                />
              ) : (
                <Document
                  file={item.pdf}
                  loading={<div className="text-center">Učitavanje...</div>}
                >
                  <Page
                    pageNumber={1}
                    scale={1.2}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                </Document>
              )}
              <div className="pt-2 text-center">
                <h3 className="text-base font-semibold">{item.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Licenses;
